// This file is shared via symlink between client and server. Server site does not support .pragma.
//.pragma library

const CompleteLevel = "CompleteLevel"
const StrokeCat = "StrokeCat"
const CollectLikes = "CollectLikes"
const EarnMedals = "EarnMedals"
const EliteV2 = "EliteV2"
const Holiday = "Holiday"

const tournamentTypes = [
    CompleteLevel,
    StrokeCat,
    CollectLikes,
    EarnMedals,
    EliteV2,
    Holiday
]

// Export for node.js
try {
    Object.assign(exports, {
        CompleteLevel,
        StrokeCat,
        CollectLikes,
        EarnMedals,
        EliteV2,
        Holiday
    })
} catch (error) {
    //console.error(error)
}
